export default __webpack_public_path__ + "static/media/file-photo.b9fa36b4.png";